import React, { useEffect, useState } from 'react';
import { MinusCircleOutlined, PicCenterOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Card, Divider, Form, Input } from 'antd';
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

export default {
    Renderer: (props) => {
        const data = props.data

        const [loaded, setLoaded] = useState(false)
        useEffect(() => {
            setLoaded(true)
        }, [])

        if (!loaded || !data.items) {
            return null
        }

        return (
            <div style={{width: "100%", height: "inherit"}}>
                <div style={{
                    width: "100%",
                    maxWidth: "600px",
                    margin: "20px auto",
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    background: "#fff",
                }}>
                    {data.items.map((item, idx) => (
                        <AccordionItem key={idx} title={item?.title} description={item?.description} />
                    ))}
                </div>
            </div>
        )

    },
    id: 'accordion',
    title: t`Accordeon`,
    description: t`Ajouter un Accordeon/FAQ`,
    icon: <PicCenterOutlined />,
    version: 1,
    allowClickInside: true,
    controls: {
        type: 'custom',
        Component: Controls
    }
}

function Controls(props) {

    const {data, onChange} = props

    const [show, setShow] = useState(true)
    const refreshForm = () => {
        setShow(false)
        setTimeout(() => setShow(true), 100)
    }
    useEffect(() => {
        refreshForm()
    }, [props.lang, props.nodeId, props.device])

    if (!show) {
        return null
    }

    if (!Array.isArray(data.items)) {
        onChange({items: []})
        return null
    }

    return (
        <div>
            <Form initialValues={data} onValuesChange={(_,values)=>{
                onChange(values)
            }}>

                <Divider><Trans>Éléments</Trans></Divider>

                <Form.List name="items">
                    {(fields, {add, remove}) => {
                        return (
                            <>
                                {fields.map(({key, name, ...restField}) => (
                                    <>
                                        <Card
                                            title={<Trans>Élément {key + 1}</Trans>}
                                            type={"inner"}
                                            key={key}
                                            extra={(
                                                <Button
                                                    type="ghost"
                                                    danger
                                                    icon={<MinusCircleOutlined/>}
                                                    onClick={() => remove(name)}
                                                />
                                            )}
                                        >
                                            <Form.Item
                                                {...restField}
                                                label={<Trans>Titre</Trans>}
                                                name={[name, 'title']}
                                                rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                                            >
                                                <Input/>
                                            </Form.Item>

                                            <Form.Item
                                                {...restField}
                                                label={<Trans>Texte</Trans>}
                                                name={[name, 'description']}
                                                rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                                            >
                                                <Input.TextArea/>
                                            </Form.Item>
                                        </Card>
                                    </>
                                ))}

                                <Form.Item>
                                    <Button
                                        type="dashed"
                                        onClick={() => add()}
                                        block
                                        icon={<PlusOutlined/>}
                                    >
                                        <Trans>Ajouter un Élément</Trans>
                                    </Button>
                                </Form.Item>
                            </>
                        )
                    }}
                </Form.List>

            </Form>
        </div>
    )
}


function AccordionItem({ title, description }) {
    const [open, setOpen] = useState(false);

    const containerStyle = {
        borderBottom: "1px solid #ddd",
    };

    const buttonStyle = {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        padding: "16px",
        fontSize: "16px",
        fontWeight: "600",
        color: "#08b3c0",
        background: "none",
        border: "none",
        outline: "none",
        cursor: "pointer",
    };

    const contentWrapperStyle = {
        overflow: "hidden",
        transition: "all 0.3s ease",
        maxHeight: open ? "200px" : "0px",
        opacity: open ? 1 : 0,
        padding: open ? "0 16px 16px" : "0 16px",
        fontSize: "14px",
        color: "#555",
    };

    const iconStyle = {
        transform: open ? "rotate(180deg)" : "rotate(0deg)",
        transition: "transform 0.3s ease",
        width: "20px",
        height: "20px",
    };

    return (
        <div style={containerStyle}>
            <button style={buttonStyle} onClick={() => setOpen(!open)}>
                <span>{title}</span>
                <svg
                    style={iconStyle}
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                </svg>
            </button>
            <div style={contentWrapperStyle}>{description}</div>
        </div>
    );
}
